import React from "react";
var __jsx = React.createElement;
var HowToBuyItem = function HowToBuyItem(_ref) {
  var src = _ref.src,
    title = _ref.title,
    description = _ref.description,
    number = _ref.number;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4 lg:flex-col lg:flex-grow-0 lg:w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: title,
    loading: "lazy",
    width: "145px",
    height: "85px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:flex lg:flex-col lg:gap-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-primary font-bold lg:text-center min-h-[1.25rem]"
  }, number), /*#__PURE__*/React.createElement("h3", {
    className: "text-primary text-base font-bold text-start mb-1 lg:text-center lg:text-xl lg:mb-0 min-h-[1.5rem] lg:min-h-[1.75rem]"
  }, title)), description && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-light-slate text-xs font-normal text-start lg:text-center min-h-[1rem] lg:min-h-[100px] lg:text-base"
  }, description)))));
};
export default HowToBuyItem;